import { useMemo } from "react";

import { SystemDropdownCategory } from "@/api";
import { useSystemDropdownOptions } from "@/common/hooks/useSystemDropdownOptions";

export interface AppointmentLabels {
  /** Resolves an appointment or attendance purpose key to its German label. */
  purposeLabelOf: (key: string | null | undefined) => string;
}

/**
 * Display-side resolution of the purpose key stored on appointments. Purposes live in two dropdown
 * categories (Termin- and Anwesenheits-Zwecke) and an appointment may reference either, so both are
 * consulted. The Ort needs nothing of the sort — it is an ordinary dropdown, so the column already
 * holds the German label.
 */
export function useAppointmentLabels(): AppointmentLabels {
  const appointmentPurposes = useSystemDropdownOptions(SystemDropdownCategory.AppointmentPurpose);
  const attendancePurposes = useSystemDropdownOptions(SystemDropdownCategory.AttendancePurpose);

  return useMemo(
    () => ({
      purposeLabelOf: (key) => {
        if (!key) {
          return "";
        }
        const fromAppointments = appointmentPurposes.labelOf(key);
        return fromAppointments === key ? attendancePurposes.labelOf(key) : fromAppointments;
      },
    }),
    [appointmentPurposes, attendancePurposes]
  );
}
